"use client";

import type { Channel } from "../hooks/useChannels";
import type { UnreadStatus } from "../hooks/useUnreads";

interface Props {
  channel: Channel;
  selected: boolean;
  onClick: () => void;
  unreadStatus?: UnreadStatus;
}

export function ChannelListItem({ channel, selected, onClick, unreadStatus = "none" }: Props) {
  const hasUnread = unreadStatus !== "none";

  return (
    <button
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "0.6rem 0.75rem",
        background: selected ? "var(--color-bg-input)" : "transparent",
        border: "none",
        borderLeft: selected ? "2px solid var(--color-text)" : "2px solid transparent",
        cursor: "pointer",
        textAlign: "left",
        fontFamily: "inherit",
        gap: 8,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: "0.8rem",
            color: selected ? "var(--color-text)" : "var(--color-text-secondary)",
            fontWeight: hasUnread ? 700 : 400,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {channel.name ?? `Channel #${channel.id}`}
        </div>
        {channel.description && (
          <div
            style={{
              fontSize: "0.7rem",
              color: "var(--color-text-faint)",
              marginTop: 2,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {channel.description}
          </div>
        )}
      </div>
      {hasUnread && (
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: unreadStatus === "working" ? "#d4a017" : "#dc2626",
            flexShrink: 0,
          }}
        />
      )}
    </button>
  );
}
